<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="false">
</sub-header>
<!--dossierHeader [projectId]="project.identifier" [infoVisible]="false" [favouriteVisible]="false" [backVisible]="false"></dossierHeader>
<div class="buttonsHeader">
  <button pButton type="button" label="Validar" icon="fa far fa-question-circle" class="p-button-warning" (click)="validate()"></button>
  <button pButton type="button" label="Guardar" icon="pi pi-check" (click)="updateAward(award)"></button>
</div-->
<p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1 " *ngIf="isLoaded()">
  <div class="container-fluid" *ngIf="isLoaded()">
    <div class="row m-b-md">
      <div class="alert alert-info row col-12" *ngIf="!elements||elements==[]">
        <span><i class="fas fa-info-circle mr-2" aria-hidden="true"></i>{{ 'General.noData' | translate }}</span>
      </div>
      <div class="col-12 m-t-md m-b-md" *ngIf="isLoaded()">
        <p-table [value]="elements" [responsive]="true" sortField="plannedPeriod.inDate" sortOrder="1">
          <ng-template pTemplate="header">
            <tr>
              <th [style.width]="'40%'">{{ 'Audit.UsersTaskAccess.User' | translate }}</th>
              <th [style.width]="'60%'">{{ 'Audit.UsersTaskAccess.Access' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-element>
            <tr>
              <td class="text-truncate">
                <span class="p-column-title">{{ 'Audit.UsersTaskAccess.User' | translate }}</span>
                <i *ngIf="element.inboxAccess" class="fas fa-user" aria-hidden="true"> </i>
                <i *ngIf="element.substitutionAccess" class="fas fa-people-carry" aria-hidden="true"> </i> {{
                element.name }}
              </td>
              <td>
                <span class="p-column-title">{{ 'Audit.UsersTaskAccess.Access' | translate }}</span>
                {{element.description}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="text-center">
              <td colspan="5"><span>{{ 'General.noData' | translate }}</span></td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</p-scrollPanel>